import React from "react";
import { Box, Button, Paper, TextField, Typography } from "@mui/material";
import { useFormik } from "formik";
import * as Yup from "yup";
import { OrganisationDetailsSchema } from "../formikSchema";
import { useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { submitUserRegistrationDetailsThunk } from "../redux/thunk/registerThunk";
import { AppDispatch } from "@store/store";
import { toast } from "react-toastify";
import { resetUserRegistration } from "../redux/registerSlice";
import { setIsUserLoggedIn, setToken } from "@modules/login/redux/loginSlice";
import { useLocation } from "react-router-dom";

const OrganisationDetails = () => {

  const navigate = useNavigate();
  const dispatch = useDispatch<AppDispatch>();
  const { gstDetails } = useSelector((state: any) => state.register);
  const location = useLocation();
  const searchParams = new URLSearchParams(location.search);
  const user_id = searchParams.get("id");
  
  const formik = useFormik({
    initialValues: {
      cin: "",
      tin: "",
    },
    validationSchema: OrganisationDetailsSchema,
    onSubmit: async (values) => {
      const { cin, tin } = values;
      const response = await dispatch(
        submitUserRegistrationDetailsThunk({
          user_id: parseInt(user_id || "0") || 0,
          cin,
          tin,
          gst_number: gstDetails?.gst_number || "",
          business_name: gstDetails?.business_name || "",
          business_nature: gstDetails?.nature_of_buisness || "",
          entity_type: gstDetails?.entity_type || "",
          pincode: Number(gstDetails?.orgAddress?.[0]?.pincode) || 0,
          registration_date: gstDetails?.registeration_number || "",
          state_name: gstDetails?.orgAddress?.[0]?.state_name || "",
          city_name: gstDetails?.orgAddress?.[0]?.city_name || "",
          district_name: gstDetails?.district_name || "",
        })
      );
      if (
        response.meta.requestStatus === "fulfilled" &&
        !response.payload.status
      ) {
        dispatch(resetUserRegistration());
        toast.success("Registration successfull!");
        const token = response.payload?.token;
        if (token) {
          dispatch(setToken(token));
          dispatch(setIsUserLoggedIn(true));
          navigate("/application-dashboard");
        }
      } else {
        console.error("Failed to submit organisation details:", response);
        toast.error("Something Went Wrong!");
      }
    },
  });
  if (!gstDetails) {
    return null;
  }

  const {
    business_name,
    orgAddress,
    entity_name,
    nature_of_business,
    district_name,
  } = gstDetails;
  if (!orgAddress || orgAddress.length === 0) {
    return null;
  }
  const { pincode, buildingNumber, streetName, state_name, city_name } =
    orgAddress[0];

  return (
    <Box
      className="box-modal"
      display="flex"
      justifyContent="center"
      sx={{ mt: { xs: 4, md: 0 }, px: { xs: 0, lg: 4 } }}
    >
      <Paper elevation={3} className="login-box pb-4 mb-4">
        <form onSubmit={formik.handleSubmit}>
          <Typography sx={{ fontWeight: 500, fontSize: "24px", pb: 3 }}>
            Enter Organisation Details
          </Typography>

          {[
            { label: "Organisation/ Business Name", value: business_name },
            // { label: "PAN Number", value: "INHK457811LK" },
            {
              label: "Complete Registered Address",
              value:
                orgAddress &&
                `${buildingNumber}, ${streetName}, ${city_name}, ${state_name} - ${pincode}`,
            },
          ].map((field, index) => (
            <Box key={index} mb={1}>
              <Typography component="label" className="org-details-label">
                {field.label}
              </Typography>
              <Typography
                className="aadhaar-register-label"
                sx={{ fontSize: "14px", mt: 1 }}
              >
                {field.value}
              </Typography>
            </Box>
          ))}

          <Box sx={{ mt: 2 }}>
            <Typography
              component="label"
              htmlFor="cin"
              className="aadhaar-register-label"
            >
              CIN Number <span className="required-field">*</span>
            </Typography>
            <TextField
              fullWidth
              id="cin"
              name="cin"
              placeholder="Enter CIN Number"
              className="aadhaar-input validation-input"
              value={formik.values.cin}
              onChange={formik.handleChange}
              onBlur={formik.handleBlur}
              error={formik.touched.cin && Boolean(formik.errors.cin)}
              helperText={formik.touched.cin && formik.errors.cin}
              sx={{ mb: 2 }}
            />

            <Typography
              component="label"
              htmlFor="tin"
              className="aadhaar-register-label"
            >
              TIN Number <span className="required-field">*</span>
            </Typography>
            <TextField
              fullWidth
              id="tin"
              name="tin"
              placeholder="Enter Tin Number"
              className="aadhaar-input validation-input"
              value={formik.values.tin}
              onChange={formik.handleChange}
              onBlur={formik.handleBlur}
              error={formik.touched.tin && Boolean(formik.errors.tin)}
              helperText={formik.touched.tin && formik.errors.tin}
              sx={{ mb: 2 }}
            />
          </Box>

          <Box className="btn-wrapper" sx={{ pt: 2, pb: 2 }}>
            <Button className="btnContinue" type="submit" fullWidth>
              Submit
            </Button>
          </Box>
        </form>
      </Paper>
    </Box>
  );
};

export default OrganisationDetails;
